const VERSION = process.env.REACT_APP_VERSION
const CACHE_EXPIRATION = 24 * 60 * 60 * 1000 // 24 hodin

export class LocalStorageCache {
  static getItem<T> (key: string, initialValue: T) {
    try {
      const storedItem = window.localStorage.getItem(key)

      if (storedItem) {
        const { value, timestamp, version } = JSON.parse(storedItem)
        if (Date.now() - timestamp <= CACHE_EXPIRATION && version === VERSION) {
          // Cache je stále platná, vrátíme ji
          return value
        } else {
          // Cache expirovala, smažeme ji
          window.localStorage.removeItem(key)
        }
      }
      // Cache expirovala nebo neexistuje, použijeme initialValue
      return initialValue
    } catch (error) {
      console.error(error)
      return initialValue
    }
  }

  static setItem<T> (key: string, valueToStore: T) {
    // try {
    const cacheData = {
      value: valueToStore,
      timestamp: Date.now(),
      version: VERSION,
    }
    window.localStorage.setItem(key, JSON.stringify(cacheData))
    // } catch (error) {
    //   console.error(error)
    // }
  }
}
